const DEFAULT_MESSAGE = 'Too many attempts. Please wait a few minutes and try again.'
const DEDUPE_MS = 5000

let lastShownAt = 0

// Dependency-free, self-mounting notice used to surface HTTP 429 (rate limit)
// responses consistently across the portal, regardless of whether a toast
// provider is mounted. Deduped so a burst of throttled requests shows once.
export function showRateLimitNotice(message) {
  if (typeof document === 'undefined') return

  const now = Date.now()
  if (now - lastShownAt < DEDUPE_MS) return
  lastShownAt = now

  const el = document.createElement('div')
  el.textContent = message || DEFAULT_MESSAGE
  el.setAttribute('role', 'alert')
  el.style.cssText = [
    'position:fixed',
    'top:20px',
    'left:50%',
    'transform:translateX(-50%)',
    'z-index:9999',
    'max-width:90%',
    'padding:12px 16px',
    'border-radius:8px',
    'background:#b91c1c',
    'color:#ffffff',
    'font-size:14px',
    'font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif',
    'box-shadow:0 4px 12px rgba(0,0,0,0.15)',
  ].join(';')

  document.body.appendChild(el)
  window.setTimeout(() => {
    el.remove()
  }, DEDUPE_MS)
}
